import { Accounts } from "../../accounts/models/accounts.model";
import { Establishments } from "../../establishments/models/establishments.model";
import { Kitchens } from "../../kitchens/models/kitchens.model";

export enum UserRoles {
    Admin = "admin",
    Commissioner = "commissioner",
    Establishment = "establishment",
    Kitchen = "kitchen"
}

export interface UserInfo {
    id: string;
    role: UserRoles;
    account?: Accounts;
    establishment?: Establishments;
    kitchen?: Kitchens;
}
